import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '第二届“电靓巴渝和美乡村”品牌故事大赛';
const baseUrl = '0716gsds';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'review',
      name: `${baseUrl}-review`,
      component: () => import('./pages/Review.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'backdetail',
      name: `${baseUrl}-backdetail`,
      component: () => import('./pages/BackDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
  ],
};

export default route;
